export default __webpack_public_path__ + "static/media/Danny-Tang.d2edbacb.png";